import React, { useRef, useState } from 'react';
import { Select, Input, Button, Divider, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

/**
 * Select con opción de agregar nuevas opciones desde el dropdown.
 * Props:
 *   value, onChange, placeholder, size, style
 *   options: string[]   — lista inicial de opciones
 *   onOptionsChange: (newList) => void  — cuando se agrega un item nuevo
 */
const CreatableSelect = ({
  value,
  onChange,
  placeholder,
  size = 'large',
  style,
  options = [],
  onOptionsChange,
  allowClear = true,
  showSearch = true,
  disabled = false,
}) => {
  const [newItem, setNewItem] = useState('');
  const inputRef = useRef(null);

  const addItem = (e) => {
    e.preventDefault();
    const trimmed = newItem.trim();
    if (!trimmed || options.includes(trimmed)) {
      setNewItem('');
      return;
    }
    const updated = [...options, trimmed];
    onOptionsChange?.(updated);
    setNewItem('');
    // Selecciona automáticamente el nuevo item
    onChange?.(trimmed);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      size={size}
      style={{ borderRadius: 8, ...style }}
      allowClear={allowClear}
      showSearch={showSearch}
      disabled={disabled}
      filterOption={(input, opt) =>
        opt?.value?.toLowerCase().includes(input.toLowerCase())
      }
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: '6px 0' }} />
          <Space style={{ padding: '4px 8px 8px', width: '100%' }}>
            <Input
              ref={inputRef}
              size="small"
              placeholder="Agregar nuevo..."
              value={newItem}
              onChange={e => setNewItem(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addItem(e); } }}
              style={{ flex: 1 }}
            />
            <Button
              type="primary"
              size="small"
              icon={<PlusOutlined />}
              onClick={addItem}
              disabled={!newItem.trim()}
            >
              Agregar
            </Button>
          </Space>
        </>
      )}
      options={options.map(o => ({ value: o, label: o }))}
    />
  );
};

export default CreatableSelect;
